import React from "react"
import { useAtom as GetAtom } from "jotai"
import {
  useEnterpriseGetOne,
  useMainEnterpriseId,
} from "../../hooks/enterprise"
import { useShopGetOne, useShopId } from "../../hooks/shop"
import CheckoutItemStackedList from "./CheckoutItemStackedList"
import { checkoutDiscountAtom, checkoutItemsAtom } from "../../store/checkout"
import { Item } from "../../libs/api/backend/src"

export default function CheckoutItemList() {
  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()
  const [, setCheckoutDiscount] = GetAtom(checkoutDiscountAtom)
  const [checkoutItems, setCheckoutItems] = GetAtom(checkoutItemsAtom)

  const { isLoading: isLoadingEnterprise, isError: isErrorEnterprise } =
    useEnterpriseGetOne(enterpriseId)
  const { isLoading: isLoadingShop, isError: isErrorShop } = useShopGetOne(
    enterpriseId,
    shopId
  )

  const onClickItemRow = (item: Item) => {
    let newCheckoutList = [...checkoutItems]

    for (let i = 0; i < newCheckoutList.length; i++) {
      if (item.id === newCheckoutList[i].id) {
        const currentCount = Number(item.count) || 0
        if (currentCount <= 1) {
          newCheckoutList.splice(i, 1)
        } else {
          newCheckoutList[i] = {
            ...newCheckoutList[i],
            count: String(currentCount - 1),
          }
        }
      }
    }

    if (!newCheckoutList.length) {
      setCheckoutDiscount("0")
    }

    setCheckoutItems(newCheckoutList)
  }

  if (
    isLoadingEnterprise ||
    isErrorEnterprise ||
    isLoadingShop ||
    isErrorShop
  ) {
    return null
  }

  if (!checkoutItems || !checkoutItems.length) {
    return <p className="p-6 text-sm text-muted-foreground">Корзина пуста</p>
  }

  return (
    <CheckoutItemStackedList
      items={checkoutItems}
      onClickItem={onClickItemRow}
    />
  )
}
